import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Modal } from 'react-bootstrap';

class ConfirmationRemoveSuperAdminModal extends Component {
  static propTypes = {
    isOpen: PropTypes.bool,
    onClose: PropTypes.func,
    onRemove: PropTypes.func,
    item: PropTypes.object
  };

  onClose = () => {
    this.props.onClose();
  };

  onRemove = () => {
    this.props.onRemove();
  };

  render() {
    const { isOpen, item } = this.props;

    const { superAdmin, subcontractorName } = item;

    return (
      <Modal
        show={isOpen}
        dialogClassName='confirmation-remove-super-admin-modal'
        backdropClassName='confirmation-remove-super-admin-backdrop'
        backdrop='static'
        container={this}
        id='confirmation-remove-super-admin'
      >
        <Modal.Body>
          <p>
            Remove{' '}
            <span style={{ fontWeight: 600 }}>{superAdmin.fullName}</span> (
            {superAdmin.email}) as {subcontractorName}'s super admin?
          </p>

          <div className='confirm-remove-file-group-btn'>
            <button
              className='btn btn-primary btn-siteone-default'
              onClick={this.onClose}
            >
              Cancel
            </button>
            <button
              className='btn btn-siteone btn-siteone-danger'
              onClick={this.onRemove}
            >
              Remove
            </button>
          </div>
        </Modal.Body>
      </Modal>
    );
  }
}

export default ConfirmationRemoveSuperAdminModal;



// WEBPACK FOOTER //
// ./src/Subcontractors/Components/confirmation-remove-super-admin-modal.js